import type { Spell } from '../../schemas/spell';

/**
 * Spell list **nuovi** del Warlock — Lista del Patrono, livelli L0/L1
 * (manuale V1, sezione "Lista degli Incantesimi" rr. 6219+, indice
 * Warlock-→-spell r. 6211).
 *
 * **Scope**: 1 spell **nuovo** del Warlock (1 L0 — *Delocalizzazione
 * Sensoriale*). Tutti gli altri spell della lista del Warlock per
 * L0/L1/L3/L5 sono **estesi in `mago.ts`/`chierico.ts`/`druido.ts`**
 * aggiungendo entry `{ classId: 'warlock' }` in `availableTo` (pattern
 * additivo, niente refactor degli ID).
 *
 * **Suppliche L0** (3 estesi):
 * - `chierico.guida`
 * - `mago.servitore-invisibile`
 * - `chierico.incutere-paura`
 *
 * **L1 del Warlock** (7 estesi):
 * - `mago.individuazione-del-magico`
 * - `mago.telepatia`
 * - `druido.ammaliare-animale`
 * - `mago.ammaliare-persona`
 * - `chierico.controllare-non-morti`
 * - `chierico.individuare-allineamento`
 * - `chierico.scudo-ultraterreno`
 *
 * **L3 del Warlock** (5 estesi, D3): Animare i Morti, Bloccare Persona,
 * Mimesi, Oscurità, Visioni Attraverso il Tempo. Il manuale (r. 6211)
 * elenca *Visioni Attraverso il Tempo* sotto la colonna L5 ma il livello
 * canonico è 3 (D3-Q5, vedi commento in `chierico.ts`).
 *
 * **L5 del Warlock** (3 estesi, D3): Contattare Altri Piani, Esilio, Voce
 * dei Taciturni.
 *
 * **Spell L7-L9 del Warlock**: rimandati a D4 (level-up L6-L10).
 *
 * **Convenzioni**:
 * - ID `warlock.<kebab-name>` per gli spell appartenenti primariamente al Warlock
 *   (a differenza di Chierico/Paladino, il Warlock non ha Tradizioni)
 */

// ============================================================================
// Suppliche (Livello 0) — 1 nuovo
// ============================================================================

const delocalizzazioneSensoriale: Spell = {
  id: 'warlock.delocalizzazione-sensoriale',
  name: 'Delocalizzazione Sensoriale',
  level: 0,
  tags: ['continuato'],
  description:
    "Il tuo patrono ti conferisce un nuovo organo di senso, equivalente a un occhio, un orecchio, un naso, una lingua o dei lunghi baffi. Descrivi come si manifesta e in che parte del tuo corpo compare. Puoi porre fine all'incantesimo in qualsiasi momento. Finché l'effetto è attivo, prendi -1 continuato a *lanciare incantesimi*.",
  availableTo: [{ classId: 'warlock' }],
};

/** 1 supplica di livello 0 nuova del Warlock. */
export const warlockCantrips: readonly Spell[] = [delocalizzazioneSensoriale];

/** 0 incantesimi di livello 1 nuovi del Warlock (tutti gli L1 sono estesi da altre liste). */
export const warlockLevel1Spells: readonly Spell[] = [];

/** Tutti gli spell **nuovi** del Warlock trascritti in questa PR (1 spell). */
export const warlockSpells: readonly Spell[] = [...warlockCantrips, ...warlockLevel1Spells];
